import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTrackClosedVersionsTray, useTrackOpenedVersionsTray } from "@air/analytics";
import { Stack } from "@air/next-icons";
import { IconButton } from "@air/primitive-icon-button";
import { memo } from "react";
import { useAssetModalPanel } from "~/components/AssetModalV2/AssetModalPanelsContextProvider";
import { VERSION_SNIPPET_DROPDOWN_BUTTON } from "~/constants/testIDs";
export const VersionsButton = /*#__PURE__*/ memo(()=>{
    const { setShowLeftPanel, showLeftPanel } = useAssetModalPanel();
    const { trackOpenedVersionsTray } = useTrackOpenedVersionsTray();
    const { trackClosedVersionsTray } = useTrackClosedVersionsTray();
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex items-center gap-2",
        children: [
            /*#__PURE__*/ _jsx(IconButton, {
                icon: Stack,
                label: "Toggle Left Panel",
                appearance: "ghost",
                color: "grey",
                size: "medium",
                "data-testid": VERSION_SNIPPET_DROPDOWN_BUTTON,
                onClick: ()=>{
                    setShowLeftPanel((prev)=>!prev);
                    if (showLeftPanel) {
                        trackClosedVersionsTray();
                    } else {
                        trackOpenedVersionsTray();
                    }
                }
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "h-6 w-px rounded-2 bg-grey-5"
            })
        ]
    });
});
VersionsButton.displayName = "VersionsButton";
